export default __webpack_public_path__ + "_/images/svg_icons/app-apple-37af08495dd68085617b43a104eb26026407a1051a80afec489bc406f81fec8c.svg";